'use client';

import { reportsGridSection } from '@stereoagency/sanity-schema';
import { ReportsGridSection as UIReportsGridSection } from '@stereoagency/ui';
import flush from 'just-flush';
import useTranslation from 'next-translate/useTranslation';
import { useRef } from 'react';
import { dateFormatterFactory, linkAsProps, sanityImageAsProps } from '@/utils';

type Props = typeof reportsGridSection.schema.reportsGridSection;

export default function ReportsGridSection({ reports }: Props) {
  const { lang } = useTranslation();
  const formatterRef = useRef(
    dateFormatterFactory(lang, {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    })
  );

  if (!reports?.length) {
    return null;
  }

  return (
    <UIReportsGridSection
      cards={flush(
        reports.map((report) => {
          if (
            !report.title ||
            !report.action?.url ||
            !report.image?.asset._ref
          ) {
            return null;
          }
          return {
            image: sanityImageAsProps(report.image),
            label: report.datetime
              ? formatterRef.current.format(new Date(report.datetime))
              : undefined,
            title: report.title,
            description: report.description,
            action: linkAsProps(report.action)
          };
        })
      )}
    />
  );
}
